import React from "react";
import { Link } from "react-router-dom";
import { galleryReal } from "@/data/gallery";

// Home teaser: ONLY photos from real jobs (never stock images) under the
// "Interventi recenti" heading.
export function HomeGallery({ t, lang }) {
  return (
    <section className="max-w-[1120px] mx-auto px-4 sm:px-6 mt-14" data-testid="home-gallery">
      <div className="flex items-end justify-between gap-3">
        <div>
          <h2 className="text-2xl sm:text-3xl font-semibold text-[hsl(var(--brand-navy))]">{t("home.gallery_title")}</h2>
          <p className="text-sm sm:text-base text-[hsl(var(--muted-foreground))] mt-1">{t("home.gallery_sub")}</p>
        </div>
        <Link to="/galleria" className="text-sm font-medium text-[hsl(var(--brand-aqua))] hover:underline shrink-0">{t("common.view_all")}</Link>
      </div>
      <div className="mt-5 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {galleryReal.slice(0, 8).map((g) => (
          <div key={g.id} className="relative rounded-xl overflow-hidden border border-[hsl(var(--border))] aspect-[4/3] bg-[hsl(var(--muted))]" data-testid={`home-gallery-item-${g.id}`}>
            <img src={g.src} alt={lang === "it" ? g.caption_it : g.caption_en} loading="lazy" decoding="async" width={400} height={400} className="h-full w-full object-cover" />
          </div>
        ))}
      </div>
    </section>
  );
}

export default HomeGallery;
